import {
  EXPORT_STATUS_CANCELED,
  EXPORT_STATUS_COMPLETED,
  EXPORT_STATUS_FAILED,
  EXPORT_STATUS_STARTED
} from '../constants/export';

export const isExportStarted = (status: number) => status === EXPORT_STATUS_STARTED;
export const isExportCanceled = (status: number) => status === EXPORT_STATUS_CANCELED;
export const isExportFailed = (status: number) => status === EXPORT_STATUS_FAILED;
export const isExportCompleted = (status: number) => status === EXPORT_STATUS_COMPLETED;